import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';
import useAuthForms from './useAuthForms';
import { useRemoveSearchParam } from './useRemoveSearchParam';
import { useMarketplaceConfig } from '../queries/marketplace';
import { usePromoCode } from './usePromoCode';

const useHandleSignUpParams = () => {
  const [searchParams] = useSearchParams();
  const { openRegisterForm } = useAuthForms();
  const removeParam = useRemoveSearchParam();
  const { isUserRegistration } = useMarketplaceConfig();
  const { promoCode, savePromoCode } = usePromoCode();

  const shouldOpenSignup = searchParams.get('signup');

  const hasHandledRef = useRef(false);

  useEffect(() => {
    if (!isUserRegistration) return;
    if (!shouldOpenSignup && !promoCode) return;
    if (hasHandledRef.current) return;

    hasHandledRef.current = true;

    if (shouldOpenSignup) removeParam('signup');

    if (promoCode) {
      savePromoCode(promoCode);
      removeParam('code');
    }

    openRegisterForm({ promoCode });
  }, [isUserRegistration, shouldOpenSignup, promoCode, openRegisterForm, removeParam, savePromoCode]);
};

export default useHandleSignUpParams;
